var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_736_26183)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_736_26183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8598 10.6528L17.5265 6.15283C17.3852 6.00622 17.1685 5.9602 16.9799 6.03613C16.7906 6.11279 16.6666 6.29613 16.6666 6.50011V8.66684H16.4999C12.916 8.66684 10 11.5828 10 15.1668V16.1667C10 16.3987 10.1633 16.592 10.3893 16.6448C10.426 16.654 10.4626 16.6581 10.4993 16.6581C10.688 16.6581 10.8686 16.5474 10.9559 16.3734C11.8933 14.4981 13.7779 13.3334 15.8746 13.3334H16.6666V15.5C16.6666 15.7041 16.7906 15.8875 16.9799 15.9634C17.1673 16.04 17.3852 15.9934 17.5265 15.8467L21.8598 11.3467C22.0465 11.1528 22.0465 10.8475 21.8598 10.6528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 22.0001H7.99998C6.89733 22.0001 6 21.1029 6 20.0001V10.667C6 9.56432 6.89733 8.66699 7.99998 8.66699H9.99995C10.3686 8.66699 10.6666 8.96496 10.6666 9.33361C10.6666 9.70226 10.3686 10.0002 9.99995 10.0002H7.99998C7.63194 10.0002 7.33324 10.2989 7.33324 10.667V20.0001C7.33324 20.3682 7.63194 20.6669 7.99998 20.6669H19.9998C20.3678 20.6669 20.6665 20.3682 20.6665 20.0001V14.6669C20.6665 14.2983 20.9644 14.0002 21.3331 14.0002C21.7018 14.0002 21.9998 14.2983 21.9998 14.6669V20.0001C21.9998 21.1029 21.1025 22.0001 19.9998 22.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_736_26183",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 29.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_736_26183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.eb97d6a823d18b945f3d382864e17db0.svg";
export { ForwardRef as ReactComponent };